module.exports = __webpack_public_path__ + "static/reduce-flight-delay-cover-4343236c7517a7020afcbadae80c2f92.png";